import { NgClass } from '@angular/common';
import { Component, HostListener, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { NavItem } from 'core/models/nav-item.model';
import { isNavItemActive } from 'core/utils/nav-item-active.util';
import { ActionTooltip } from 'ui/action-tooltip/action-tooltip';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, NgClass, ActionTooltip],
  templateUrl: './navbar.html',
})
export class Navbar {
  private readonly router = inject(Router);

  readonly navItems = input<NavItem[]>([]);
  readonly topOffset = input('50px');

  protected readonly openGroupLabel = signal<string | null>(null);
  private readonly currentUrl = signal(this.router.url);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.currentUrl.set(this.router.url);
        this.closeMenus();
      });
  }

  protected hasChildren(item: NavItem): boolean {
    return (item.children?.length ?? 0) > 0;
  }

  protected isItemActive(item: NavItem): boolean {
    return isNavItemActive(item, this.currentUrl());
  }

  protected isDescendantActive(item: NavItem): boolean {
    return isNavItemActive(item, this.currentUrl());
  }

  protected closeMenus(): void {
    this.openGroupLabel.set(null);
  }

  protected onGroupClick(event: Event, item: NavItem): void {
    event.stopPropagation();
    if (this.openGroupLabel() === item.label) {
      this.closeMenus();
      return;
    }
    this.openGroupLabel.set(item.label);
  }

  @HostListener('document:click')
  protected handleDocumentClick(): void {
    this.closeMenus();
  }
}
